import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { isPresent } from '@ember/utils';
import { ImportState } from 'cio/models/import';

const STATE_ROUTES = {
  [ImportState.Imported]: 'index',
  [ImportState.Failed]: 'imports.csv.setup.index',
  [ImportState.Preprocessed]: 'imports.csv.setup.map',
  [ImportState.Validated]: 'imports.csv.setup.review',
  [ImportState.Preprocessing]: 'imports.csv.setup.preprocessing',
  [ImportState.Validating]: 'imports.csv.setup.validating',
  [ImportState.Importing]: 'imports.csv.setup.importing',
};

export default class SetupRoute extends Route {
  @service store;

  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      name: 'Add by CSV',
      path: 'segments.segment.imports.csv.setup',
      model,
    };
  }

  model({ import_id }) {
    return this.store.findRecord('import', import_id);
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    model.get('segment').then((segment) => controller.set('segment', segment));
  }

  redirect(model, transition) {
    let { state } = model;

    let route = STATE_ROUTES[state];
    let targetName = `segments.segment.${route}`;

    if (isPresent(route) && transition.targetName !== targetName) {
      let segmentId = model.belongsTo('segment').id();

      if (segmentId) {
        if (state === ImportState.Imported) {
          this.router.transitionTo(targetName, segmentId);
        } else {
          this.router.transitionTo(targetName, segmentId, model);
        }
      }
    }
  }
}
